import { createSlice } from "@reduxjs/toolkit";
import { UserRoleListViewModel } from "../../security/model/user-role";

interface AdminRolesState {
  userRoles: UserRoleListViewModel;
  isLoading: boolean;
}

const emptyRoles: UserRoleListViewModel = {
  internalUserRoles: [],
  externalUserRoles: []
};

const initialState: AdminRolesState = {
  userRoles: emptyRoles,
  isLoading: false,
};

const adminRolesSlice = createSlice({
  name: "adminRoleContext",
  initialState,
  reducers: {
    resetAdminRoleContext() {
      return initialState;
    }
  },
});

export const {
  resetAdminRoleContext
} = adminRolesSlice.actions;
export default adminRolesSlice.reducer;
